























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import {
  SET_SEARCH,
  SET_SELECT
} from '@/system/store/action-types'
import {
  GET_PROJECTS
} from '@/system/store/getter-types'
import { IActionType } from '@/system/store'
import { IProjectStore, ISelectSystem } from '@/features/projectList/store'
import { PROJECT_SYSTEM_TYPES, ALL_PROJECT_TYPES } from '@/constants'
import { projectListLocalisationKeys } from '@/features/projectList/projectList.localisation'

@Component
export default class SearchPanel extends Vue {
  private translations = projectListLocalisationKeys
  projectType = PROJECT_SYSTEM_TYPES
  select = ALL_PROJECT_TYPES
  search = ''

  @Action(SET_SEARCH)
  setSearch!: IActionType
  @Action(SET_SELECT)
  setSelect!: IActionType
  @Getter(GET_PROJECTS)
  projectList!: IProjectStore[]

  private handleSearch (search: string) {
    return this.setSearch(search)
  }

  private handleSelect (select: ISelectSystem) {
    return this.setSelect(select)
  }
}

